import { render, staticRenderFns } from "./DialogEditRole.vue?vue&type=template&id=0f717bcf&scoped=true&"
import script from "./DialogEditRole.vue?vue&type=script&lang=js&"
export * from "./DialogEditRole.vue?vue&type=script&lang=js&"
import style0 from "./DialogEditRole.vue?vue&type=style&index=0&id=0f717bcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f717bcf",
  null
  
)

export default component.exports